import {
  Box,
  PanelHeaderIcon,
  Stack,
  Space,
  Heading,
  UnorderedList,
  Loader,
  QRCode,
  useIsMobileLayout,
} from "@dbn/omnichannel-design-system-g4p";
import { RuntimeLocaleKey, useFormatMessage } from "../../intl";
import { DownloadAppButton } from "./DownloadAppButton/DownloadAppButton";
import * as classes from "./SummaryAndDownloadCommonStyles.css";
import { useQuery } from "../../useAPI";
import { mobileAppQRCode } from "./api";
import * as remoteData from "../../RemoteData";
import { constNull, pipe } from "fp-ts/function";
import { spaceUnit } from "@dbn/omnichannel-design-system-g4p/lib/styleConstants";

type Props = {
  stepNo: number;
  isCf: boolean;
};

function QRCodeImage() {
  const [qrCode] = useQuery(mobileAppQRCode, {
    component: "eShopFE",
    size: 150,
  });
  const formatMessage = useFormatMessage();

  return pipe(
    qrCode,
    remoteData.fold(
      () => <Loader />,
      constNull,
      qrCode => (
        <QRCode
          code={qrCode}
          size={150}
          ariaLabelMessage={formatMessage(
            "generic.downloadAppQrCode.altImage" as RuntimeLocaleKey
          )}
        />
      )
    )
  );
}

export function Download(props: Props) {
  const formatMessage = useFormatMessage();
  const isMobileLayout = useIsMobileLayout();

  const translationPlaceholder = props.isCf ? ".CF" : "";

  return (
    <Box column shrink className={classes.wrapper}>
      <Stack units={4} vAlignContent={isMobileLayout ? "top" : "center"}>
        <PanelHeaderIcon
          variant="complete"
          type="number"
          value={props.stepNo}
        />
        <Heading size="small" weight="medium">
          {formatMessage(
            `SummaryAndDownload${translationPlaceholder}.Download.title` as RuntimeLocaleKey
          )}
        </Heading>
      </Stack>
      <Space units={9} />
      <Box>
        <Heading size="x-small" weight="regular">
          {formatMessage(
            `SummaryAndDownload${translationPlaceholder}.Download.ListTitle` as RuntimeLocaleKey
          )}
        </Heading>
      </Box>
      <Space units={4} />
      <Box shrink grow>
        <UnorderedList size="large" listStyle="bullet">
          {[
            formatMessage(
              `SummaryAndDownload${translationPlaceholder}.Download.step1` as RuntimeLocaleKey
            ),
            formatMessage(
              `SummaryAndDownload${translationPlaceholder}.Download.step2` as RuntimeLocaleKey
            ),
            formatMessage(
              `SummaryAndDownload${translationPlaceholder}.Download.step3` as RuntimeLocaleKey
            ),
          ]}
        </UnorderedList>
      </Box>
      <Box
        hAlignContent={isMobileLayout ? "center" : undefined}
        style={{ justifyContent: "center" }}
      >
        {!isMobileLayout && <Space units={11} />}
        <Stack
          column={isMobileLayout}
          units={3}
          style={{ alignItems: "center" }}
        >
          <Box style={{ padding: 2 * spaceUnit }} column hAlignContent="center">
            {QRCodeImage()}
          </Box>
          {!isMobileLayout && <Space units={9} />}
          <Box column shrink>
            <DownloadAppButton
              platform="iOS"
              ariaLabelMessage={formatMessage(
                "SummaryAndDownload.link.app.ios.alt" as RuntimeLocaleKey
              )}
            />
            <DownloadAppButton
              platform="Android"
              ariaLabelMessage={formatMessage(
                "SummaryAndDownload.link.app.android.alt" as RuntimeLocaleKey
              )}
            />
          </Box>
          {!isMobileLayout && <Space units={12} />}
        </Stack>
      </Box>
    </Box>
  );
}
